// External imports
import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

// Internal imports
import "./styles/index.css";
import { RootRoutes } from "./pages/rootRoutes";
import { MainPageRoutes } from "./pages/routes";

// Language Context
import { LanguageProvider } from "./core/translations/LanguageContext";

/**
 * Compiles all routes for the application
 * @returns Array of route configurations
 */
function compileRoutes() {
    return RootRoutes.concat(MainPageRoutes);
}

/**
 * Root component that provides language context to the entire app
 */
const Root: React.FC = () => {
    const router = createBrowserRouter(compileRoutes());

    return (
        <LanguageProvider>
            <RouterProvider router={router} />
        </LanguageProvider>
    );
};

// Initialize React root and render application
const rootElement = document.getElementById("root");
if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(<Root />);
} else {
    console.error("Failed to find root element");
}
